<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新闻列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 新闻列表 -->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;margin-top: 30px;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column prop="title" align="center" label="标题">
      </el-table-column>
      <el-table-column prop="type" align="center" label="分类" width="100">
      </el-table-column>
      <el-table-column prop="top" align="center" label="置顶" width="120">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.top" active-value="1" inactive-value="0" @change="setswitch('top',scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="is_show" align="center" label="显示" width="120">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.is_show" active-value="1" inactive-value="0" @change="setswitch('is_show',scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createdtime" align="center" label="创建时间" width="140">
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="100">
        <template slot-scope="scope">
          <router-link :to="{ path: '/news/article/'+scope.row.id }" type="text" size="small">编辑</router-link>
          <el-button @click="deleteNews(scope.row.id)" type="text" size="small" style="margin-left: 10px;">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import { newsList,updateNews,delNews } from '../../api/baseset'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        formInline: {
          page: 1,
          limit: 10
        },
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        listData: [], //表格数据
      }
    },
    components:{
      Pagination
    },
    created() {
      this.getdata(this.formInline)
    },
    methods: {
      getdata(parameter) {
        this.loading = true
        newsList(parameter).then(res => {
            this.loading = false
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        ).catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
      },
      deleteNews(id) {
        this.$confirm('您确定要删除新闻吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {id:id}
          delNews(data).then(res => {
            if(res.code == 0){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getdata(this.formInline)
            }else{
              this.$message.error(res.msg)
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      setswitch(type,row) {
        var data = {}
        if(type == 'is_show'){
          data = {id:row.id,is_show:row.is_show}
        }
        if(type == 'top'){
          data = {id:row.id,top:row.top}
        }
        updateNews(data).then(res => {
          if(res.code == 0){
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else{
            this.$message.error(res.msg)
          }
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/news/articleList.vue